export class Error403 extends Error {
  public name = "403";
  public message = "Not allowed to access this page";
}

export class UgError extends Error {
  public name = "UgError";
}
